import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { ReactComponent as Delete } from 'assets/vectors/delete-icon.svg'
import { ReactComponent as Down } from 'assets/vectors/chevron-down.svg'

import { ReactComponent as EditIcon } from '../../../assets/vectors/edition.svg'
import { ReactComponent as Remove } from '../../../assets/vectors/remove.svg'
import infoIcon from '../../../assets/vectors/Icon_Information.svg'

import { PRODUCT_PIVOTS_ROUTE, CONFIG_PRODUCT_ROUTE } from '../../../routes/consts'
import { setSelectedProduct, setSelectedPivot, toggleCartOpen } from '../../../store/actions/cart'

import './ProductList.scss'

const ProductList = ({ products, router, onRemoveProduct, onRemovePivot }) => {
  const dispatch = useDispatch()
  const [expanded, setExpanded] = useState({}) // { productName: true/false }

  const toggleExpand = name => {
    setExpanded(prev => ({ ...prev, [name]: !prev[name] }))
  }

  const productNamesKey = products?.map(p => p.name).join('|') || ''

  useEffect(() => {
    if (products?.length) {
      setExpanded(prev => {
        const next = { ...prev }
        products.forEach(p => {
          if (!(p.name in next)) next[p.name] = true
        })
        return next
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productNamesKey])

  return (
    <>
      <ul className="cart-product-list__container">
        {products.map(c => {
          const pivots = c.pivots && Object.values(c.pivots)
          const isExpanded = expanded[c.name]

          return (
            <li key={c.name} className="cart-product-list__item">
              <div className="cart-product-list__item__name">
                <h1 className="cart-product-list__item__product">{c.name}</h1>
                <div style={{ display: 'flex', gap: 30, alignItems: 'center' }}>
                  <EditIcon
                    style={{ cursor: 'pointer' }}
                    width={16}
                    height={16}
                    onClick={() => {
                      dispatch(setSelectedProduct(c))
                      dispatch(toggleCartOpen())
                      if (pivots.length > 1) router.navigate({ name: PRODUCT_PIVOTS_ROUTE })
                      else {
                        dispatch(setSelectedPivot(pivots[0]))
                        router.navigate({ name: CONFIG_PRODUCT_ROUTE })
                      }
                    }}
                  />

                  <Delete style={{ cursor: 'pointer' }} onClick={() => onRemoveProduct(c.id)} />
                  <Down
                    width={10}
                    height={10}
                    style={{
                      cursor: 'pointer',
                      transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease',
                    }}
                    onClick={() => toggleExpand(c.name)}
                  />
                </div>
              </div>

              <div
                className={`cart-product-list__item__pivot-wrapper ${isExpanded ? 'expanded' : ''}`}
              >
                <div
                  className="cart-product-list__item__pivot"
                  style={{
                    marginTop: 20,
                    display: 'flex',
                    gap: 15,
                    flexDirection: 'column',
                  }}
                >
                  {pivots.map(p => (
                    <div key={p.name} style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <p className="cart-product-list__item__pivots">
                        {`${p.name} - Dosagem ${p.dosage} ${c.unitMeasure} - ${p.quantity} ${c.unitMeasure}`}
                      </p>

                      <div style={{ display: 'flex', gap: 25, alignItems: 'center' }}>
                        {/* {!!c.stock && !c.usedStock && !c.ignoreStock && (
                          <img width={16} height={16} src={dangerIcon} alt="Alerta de Sobra" />
                        )} */}
                        <Remove
                          style={{ cursor: 'pointer' }}
                          onClick={() => onRemovePivot(c.id, p.id)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                
                <p
                  className="cart-product-list__item__pivots"
                  style={{ marginTop: 20, fontWeight: 'bold' }}
                >
                  {`Quantidade total é ${pivots.reduce((acc, item) => acc + item.quantity, 0).toFixed(2)} ${
                    c.unitMeasure
                  }`}{' '}
                </p>
                {!!c.stock && !c.usedStock && !c.ignoreStock && <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    gap: '5px',
                    flexDirection: 'row!important',
                    alignItems: 'center',
                    height: 20,
                    marginTop: 15,
                  }}
                >
                  <img
                    width={16}
                    height={16}
                    src={infoIcon}
                    alt="Informação de limite de aplicações"
                  />
                  <p style={{fontSize:12}}>Você já possui esse produto em estoque na fazenda.</p>
                </div>}
                {c.usedStock && (
                  <p className="cart-product-list__item__stock">
                    {`Estoque - ${c.usedStock.toFixed(2)} ${c.unitMeasure}`}
                  </p>
                )}
              </div>
            </li>
          )
        })}
      </ul>
    </>
  )
}

export default ProductList
